import { useEffect } from 'react';

import { useAuth } from '@/hooks/useAuth';

const TRACKING_SCRIPT_SELECTOR = 'script[data-website-id]';

const identifyUser = (email) => window.umami?.identify(email, { email });

const UmamiIdentify = () => {
    const { isAuthenticated, user } = useAuth();

    useEffect(() => {
        if (!isAuthenticated || !user?.email) {
            return undefined;
        }
        if (window.umami) {
            identifyUser(user.email);
            return undefined;
        }
        const trackingScript = document.querySelector(TRACKING_SCRIPT_SELECTOR);
        if (!trackingScript) {
            return undefined;
        }
        const identifyOnLoad = () => identifyUser(user.email);
        trackingScript.addEventListener('load', identifyOnLoad);
        return () => trackingScript.removeEventListener('load', identifyOnLoad);
    }, [isAuthenticated, user?.email]);

    return null;
};

export { UmamiIdentify };
